import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

const justify = { textAlign: "justify" };

const Privacy = ({ onDismiss }) => {
  return (
    <div className={"privacy-terms-policy"} style={{ height: "100%" }}>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            {!onDismiss && <IonBackButton text="" />}
          </IonButtons>
          <IonTitle>Privacy Policy</IonTitle>
          {onDismiss && (
            <IonButtons slot="end">
              <IonButton fill="clear" onClick={onDismiss}>
                Close
              </IonButton>
            </IonButtons>
          )}
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard style={{ boxShadow: "none" }}>
          <IonCardHeader>
            <IonCardTitle>Privacy Policy</IonCardTitle>
            <IonCardSubtitle>Last Updated: June 3, 2021</IonCardSubtitle>
          </IonCardHeader>
          <IonCardContent>
            <div style={justify}>
              <p>
                Oshi, LLC and our affiliates with whom you have a relationship
                (“Oshi”, “our”, “us”, or “we”)are committed to protecting the
                privacy of our users and customers (“you”, “your”) and to
                providing you with a secure online experience. This Privacy
                Policy (“Policy”) applies to personal information we collect
                through our website, mobile applications, and other related
                platforms(collectively, the “Oshi Platforms”). This Policy is
                designed to inform you about the types of personal information
                we gather, how we use the information, with whom we share it,
                and the choices you can make about our use of the information.
                This Policy also describes the security measures we take to
                safeguard the information and how you can contact us about our
                privacy practices. Please read the complete Policy below and
                contact us if you have any questions. ThisPrivacy Policy is
                incorporated into, and considered a part of, our Terms of
                Service, and our Terms of Rewards. Each capitalized term used
                but not defined in this Privacy Policy shall have the meaning
                given to such term in theTerms of Service and/or Terms of
                Rewards, as applicable.Visitors to the Oshi Platform are subject
                to our data collection and usage polices. When you access or use
                our Oshi Platform and web-based applications, you acknowledge
                that you have read this Policy, understand the contents of this
                Policy, and agree to the terms of this Policy.Your use of our
                Oshi Platform and any dispute over privacy is subject to this
                Policy. This Policy applies to Personal Information (as defined
                below) we obtain from you through our website,products,
                services, and web-based applications.
              </p>
              <br />
              <p>
                <strong>Information We Obtain and How We Use It</strong>
              </p>
              <br />
              <p>
                You can visit our website, read materials, and browse our
                products and other company information without giving us any
                personally identifiable information—that is, information that
                could identify you as an individual (“Personal Information”).
                The following are examples of the type of Personal Information
                that may be collected: your first and last name, physical
                address,telephone number, or e-mail address. The type of
                Services used will determine the specific typeof information
                collected.
              </p>
              <br />
              <p>
                In order to provide you with the most efficient and enhanced
                personalized service and attention,and to accommodate certain
                requests, we request Personal Information about you in certain
                circumstances and collect certain non-personal information
                automatically. Here are ways you may provide the information and
                the types of information you may submit. We also describe how we
                may use the information you provide to us.
              </p>
              <br />
              <p>
                <strong>Personal Information We Obtain</strong>
              </p>
              <br />
              <p>
                We collect Personal Information that you volunteer to us when
                you make create an account,make purchases, fill in information
                on forms, chat with us on the Oshi Platform, or send us an
                e-mail to request information about products, support, or
                training. In most cases, an asterisk (*)indicates the required
                information on a form. You may choose to provide additional
                information within fields that are not required. We may use the
                information provided to respond to your inquiry, contact you
                about your request, ask a question, provide announcements about
                products and future events, conduct surveys, consider any
                application for employment that you submit through our Oshi
                Platform, and contact you for other reasons related to offering
                and improving our services. We may also offer visitors to our
                Oshi Platform various features, and we may change these features
                from time to time. We may ask you to submit certain Personal
                Information so that we can provide you with those features.
              </p>
              <br />
              <p>
                Users should also be aware that when they voluntarily disclose
                Personal Information on any message board or the like, that such
                information, along with any substantive information disclosed,
                can be collected and used by third parties and may result in
                unsolicited messages from other users or third parties. Such
                activities are beyond our control. Personal Information
                disclosed in such manner becomes public information and you
                should exercise caution when deciding to disclose your Personal
                Information. Additionally, the Oshi Platform may contain links
                to other websites and we are not responsible for the privacy
                practices or the content of such third party sites.
              </p>
              <br />
              <p>
                <strong>
                  Information We Obtain When You Purchase Merchant Listings
                  through the Oshi Platform
                </strong>
              </p>
              <br />
              <p>
                The Oshi Platform may make available vouchers, promotions,
                coupons, discounts, or other related offers (collectively,
                “Merchant Listings”) for services, goods, or products provided
                by third parties (“Merchants”) to individuals seeking such
                Merchant Listings (“Purchasers”), as well as references and
                links to Merchant Listings (making such Merchant Listings
                available on the Oshi Platform, hereinafter, the “Services”).
              </p>
              <br />
              <p>
                As in any transaction, when you purchase Merchant Listings, your
                credit card company will necessarily receive all relevant
                information about the name of the vendor, item(s)
                purchased,date, total cost, and other information necessary to
                process the transaction. We will not otherwise provide any
                Personal Information to your credit card company without your
                permission. We and our technical and fulfillment agents,
                partners, and consultants follow carefully prescribed procedures
                to safeguard credit card data in connection with your
                transactions and adhere to certain legal requirements.
              </p>
              <br />
              <p>
                Oshi uses a third-party, OpenNode, Inc. (“OpenNode”), to
                facilitate the Services and transactions of Merchant Listings.
                By enrolling in or using any Oshi Platform, you acknowledge that
                you have read and understand OpenNode’s Terms and Conditions
                (found at https://www.opennode.com/terms-and-conditions/) and
                OpenNode’s Privacy Policy (found
                athttps://www.opennode.com/privacy-policy/) and further agree to
                be bound by all terms found therein.
              </p>
              <br />
              <p>
                <strong>Information We Obtain by Automated Means </strong>
              </p>
              <br />
              <p>
                Certain non-personal information and data may be automatically
                collected through the standard operation of our servers or
                through the use of cookies, non-cookie-based tokens, web server
                logs,tracking pixels, and web beacons, either by us or third
                party advertisers. Cookies are small text files that website
                send to your computer or other Internet-connected device to
                identify your browser uniquely or to store information or
                settings in your browser. These cookies are used to recognize
                repeat visitors, permit access to and use of the Oshi Platform,
                and allow the Oshi Platform to track usage behavior and compile
                data that will allow content improvements and targeted
                advertising. Your browser may tell you when you receive certain
                types of cookies and how to restrict or disable certain cookies.
                Information of this nature collected by us shall be used for
                statistical purposes only. No Personal Information is disclosed
                to any of these third parties in providing these reports. Please
                note that without cookies, you may not be able to use all of the
                features our Oshi Platform offers and may not be able to
                purchase products that use a “shopping cart.” Please note that
                you can order or pay for any product or service by telephone by
                callingCustomer Service at [phone number]. Non-cookie-based
                tokens, or encoded URL-based identifiers that track e-mail
                click-thru activity or time-sensitive password reset keys, will
                work in scenarios where cookies are disabled or a session has
                not been initiated.
              </p>
              <br />
              <p>
                Our web servers may log information such as your operating
                system type, browser type, domain,and other system settings, as
                well as the language your system uses and the country and
                timezone where your device is located. The web server logs may
                also record information such as the address of the web page that
                referred you to our Oshi Platform and the IP address of the
                device you use to connect to the Internet. The web server logs
                may also log information about your interaction with the Oshi
                Platform, such as which pages you visit. To control which web
                servers collect information by automated means, we may place
                tags called “web beacons”―small files that link web pages to
                particular web servers and their cookies. We may also collect
                information from your browser, such as your browsing history,
                and use it in conjunction with data gathered from forms and
                e-mails to help us understand and respond to your needs
              </p>
              <br />
              <p>
                We also use third-party web analytic services of Google
                Analytics on our Oshi Platform. GoogleAnalytics is a web
                analysis service provided by Google, Inc. The service providers
                who administer these services may use automated means, including
                cookies and web beacons, to help us analyze how users use our
                Oshi Platform. The information collected by these automated
                means, including your IP address, is available to the service
                providers, which use the information to evaluate your use of our
                Oshi Platform. To learn more about how Google Analytics collects
                and processes data, please visit{" "}
                <a
                  href="https://www.google.com/policies/privacy/partners"
                  target={"_blank"}
                >
                  this link
                </a>{" "}
                maybe updated by Google from time to time. Google Analytics
                offers a number of services,including Google Analytics
                Advertising (“GAA”). We use the following functions provided
                byGAA: Remarketing with Google Analytics, Google Display Network
                Impression Reporting,Google Analytics Demographics and Interest
                Reporting, AdWords, and DoubleClick Services.
              </p>
              <br />
              <p>
                To learn how to opt out of Google Analytics, visit:
                https://tools.google.com/dlpage/gaoptout.
              </p>
              <br />
              <p>
                We also use the third-party web analytic services of
                MarketScale, which utilizes tools like LeadsPortal and Hotjar.
                Leads Portal provides a reverse IP lookup service, which can
                determine the domain name associated with a certain IP address.
                The data provided to us by Leads Portal does not allow us to
                identify an individual person who visits the Oshi Platform. We
                use Hotjar inorder to better understand our users’ needs and to
                optimize this service and experience. Hotjar is a technology
                service that helps us better understand our users’ experience
                (e.g. how much time they spend on which pages, which links they
                choose to click, what users do and don’t like,etc.) and this
                enables us to build and maintain our service with user feedback.
                Hotjar uses cookies and other technologies to collect data on
                our users’ behavior and their devices. This includes a device's
                IP address (processed during your session and stored in a
                de-identified form), device screen size, device type (unique
                device identifiers), browser information,geographic location
                (country only), and the preferred language used to display our
                webOshi Platform. Hotjar stores this information on our behalf
                in a pseudonymized user profile. Hotjar is contractually
                forbidden to sell any of the data collected on our behalf. For
                further details, please see the ‘about Hotjar’ section of{" "}
                <a
                  href={
                    "https://help.hotjar.com/hc/en-us/categories/115001323967-About-Hotjar"
                  }
                  target={"_blank"}
                >
                  Hotjar’s support Oshi Platform
                </a>{" "}
                and Hotjar’s privacy policy,which can be found by following{" "}
                <a href="https://www.hotjar.com/privacy" target={"_blank"}>
                  this link
                </a>
                .
              </p>
              <br />
              <p>
                We use Hotjar in order to better understand our users’ needs and
                to optimize this service and experience. Hotjar is a technology
                service that helps us better understand our users’ experience
                (e.g. how much time they spend on which pages, which links they
                choose to click, what users do and do not like, etc.) and this
                enables us to build and maintain our service with user feedback.
                Hotjar uses cookies and other technologies to collect data on
                our users’ behavior and their devices (in particular, a device’s
                IP address (which is captured and stored only in anonymized
                form), device screen size, device type (unique device
                identifiers), browser information, geographic location (country
                only), preferred language used to display our website). Hotjar
                stores this information in a pseudonymized user profile. Neither
                Hotjar nor we will ever use this information to identify
                individual users or to match it with further data on an
                individual user. For further details, please see.
              </p>
              <br />
              <p>
                You can opt out to the creation of a user profile, Hotjar’s
                storing of data about your usage of our Oshi Platform, and
                Hotjar’s use of tracking cookies on other website by following
                this{" "}
                <a
                  href="https://www.hotjar.com/legal/compliance/opt-out"
                  target={"_blank"}
                >
                  opt-out link
                </a>
                .
              </p>
              <br />
              <p>
                We use information collected online through cookies,
                non-cookie-based tokens, web beacons, and other automated means
                for many purposes, such as customizing and enhancing our
                visitors’ experience on the Oshi Platform, facilitating use of
                the Oshi Platform, collecting statistics about your visits to
                the Oshi Platform, and understanding how our visitors browse our
                Oshi Platform. We also use the information to help diagnose
                technical and service problems, administer our Oshi Platform,
                and identify visitors to our Oshi Platform consistent with this
                Policy. We use clickstream data to determine how much time our
                visitors spend on the web pages of our Oshi Platform, how our
                visitors navigate through our Oshi Platform, and how we may
                enhance our Oshi Platform to meet our visitors’ needs.
              </p>
              <br />
              <p>
                <strong>“Do Not Track” Signals</strong>
              </p>
              <br />
              <p>
                You should be aware that some websites do keep track of your
                browsing activities when they serve you content, which enables
                them to tailor what they present to you. Your browser may allow
                you to transmit a Do Not Track (“DNT”) signal to websites and
                online services you visit. Like many other websites and online
                services, our Oshi Platform does not currently process or
                respond to DNT signals from your browser or other mechanisms
                that enable choice. Personal information about our visitors’
                online activities over time and across third-party websites may
                be collected by us, our affiliates, and our service providers.
              </p>
              <br />
              <p>
                <strong>Social Media Widgets </strong>
              </p>
              <br />
              <p>
                Our Oshi Platform includes social media functions, such as the
                Facebook, Twitter, YouTube, LinkedIn, and Instagram widgets.
                These widgets may collect information about which pages visitors
                visit on our Oshi Platform and the IP address of the device
                visitors use to connect to the Internet. The widgets may also
                set a cookie to ensure the features are functioning properly.
                Social media functions and widgets are hosted by either a third
                party or directly on the Oshi Platform. Your interactions with
                the social media functions and widgets located on the Oshi
                Platform are governed by the privacy policies of the companies
                that provide them. If you use any of the social media functions
                or widgets on our Oshi Platform, we strongly suggest you review
                the privacy policies of the companies that provide those
                functions and features.
              </p>
              <br />
              <p>
                <strong>LinkedIn Members</strong>
              </p>
              <br />
              <p>
                For our Oshi Platform visitors who are LinkedIn members and who
                visit our Oshi Platform from LinkedIn, our Oshi Platform may use
                tracking pixels―transparent graphic images placed on webpages.
                These tracking pixels, in combination with cookies, collect
                information contained within your LinkedIn profile as well as
                your access of and interaction with the web pages that contain
                the pixels. We work with LinkedIn to provide Sponsored Updates
                and advertisements about our Services on your LinkedIn News
                feed. You may also receive Sponsored InMails to your LinkedIn
                email account based on your visits to our Oshi Platform and your
                perceived interests when you submit a form on our Oshi
                Platforms. To learn how to opt out of Sponsored InMail messages,
                navigate to “Settings & Privacy” in your LinkedIn account,
                select the “Communications” tab, and then select “No” under
                “Allow LinkedIn partners to show you Sponsored InMail.”
              </p>
              <br />
              <p>
                <strong>Other Uses of Information</strong>
              </p>
              <br />
              <p>
                We reserve the right to use or disclose any information without
                notice or consent for the following purposes: as needed to
                satisfy any law, regulation, or other authorized request; to
                conduct investigations of consumer complaints or possible
                breaches of law or contract; to protect the integrity of our
                Oshi Platform and our property; to protect the safety of our
                visitors or others; to fulfill your requests; or to cooperate in
                any legal investigation.
              </p>
              <br />
              <p>
                Certain non-personal information may be gathered and stored to
                log files as you use our Oshi Platform as described in
                “Information We Obtain by Automated Means.” At the present time,
                we do not share, disclose, or sell any Personal Information we
                collect. Should we determine to make such information available
                to third parties we will endeavor to provide notification of
                such intention and offer a reasonable opportunity for you to
                indicate a preference that such information not be shared. Any
                e-mail addresses submitted to Oshi or collected by Oshi are used
                to deliver important information to you about our products,
                services, and our Oshi Platform. We may use Personal Information
                you provide on our Oshi Platform to operate, evaluate, and
                improve our business. Specific uses include developing new
                products and services; managing our communications; performing
                market research; advertising and marketing; evaluating the
                effectiveness of our advertising and marketing; analyzing our
                products, services, and Oshi Platform; and administering our
                Oshi Platform. We may also use the information to protect
                against and prevent fraud, claims, and other liabilities and to
                comply with or enforce applicable legal requirements, industry
                standards, and our policies and terms. We may also use the
                information we obtain through the Oshi Platform in other ways
                for which we provide specific notice at the time of collection.
              </p>
              <br />
              <p>
                <strong>How Long We Keep Information</strong>
              </p>
              <br />
              <p>
                The length of time we keep the personal data we collect depends
                on the purpose for which we collected it. In all cases, we keep
                this information for as long as is necessary to fulfil the
                purpose for which we collected it. We will then delete the
                personal data, unless we are legally required to retain it to
                comply with legal requirements.
              </p>
              <br />
              <p>
                <strong>Information We Share</strong>
              </p>
              <br />
              <p>
                Except as described in this Policy, we do not sell or otherwise
                disclose Personal Information we collect on our Oshi Platform.
                We may share Personal Information we collect on the Oshi
                Platform with affiliates and service providers that perform
                services on our behalf. We do not authorize those service
                providers to use or disclose the Personal Information except as
                necessary to perform services on our behalf or to comply with
                legal requirements.{" "}
              </p>
              <br />
              <p>
                In addition, we may disclose Personal Information about you (a)
                if we are required to do so by law or legal process (such as a
                court order or subpoena), (b) to law enforcement authorities or
                other government officials, (c) when we believe disclosure is
                necessary to appropriate or prevent physical harm or financial
                loss, or (d) in connection with an investigation of suspected or
                actual fraudulent or illegal activity. We reserve the right to
                transfer Personal Information we have about you in the event we
                sell or transfer all or a portion of our business or assets
                (including in the event of a reorganization, dissolution, or
                liquidation). Should such a sale or transfer occur, we will use
                reasonable efforts to direct the transferee to use Personal
                Information you have provided to us in a manner consistent with
                this Policy.
              </p>
              <br />
              <p>
                <strong>Your Rights and Choices </strong>
              </p>
              <br />
              <p>
                We offer you certain choices about how we communicate with you
                and what information we obtain from you. As required by
                applicable law, you may withdraw consent you previously provided
                to us. We will apply your preferences going forward. You may
                exercise these choices by advising us of your preference by
                e-mail or by contacting us as specified in the “How to Contact
                Us” section below. You may also, at any time, object―on
                legitimate grounds and free of charge―to the processing of your
                Personal Information.
              </p>
              <br />
              <p>
                Subject to applicable law, you may also have the right to
                request access to and receive information about the personal
                information we maintain about you, update and correct
                inaccuracies in your personal data, and have the information
                blocked or deleted, as appropriate. The right to access Personal
                Information may be limited in some circumstances by local law
                requirements. You may contact us by e-mail or as described in
                the “How to Contact Us” section below to update your
                preferences, ask us to remove your information from our mailing
                lists, or submit other requests.
              </p>
              <br />
              <p>
                If you are located in the European Economic Area (“EEA”) or
                Switzerland, you may have the following rights in relation to
                the personal data that we hold about you: (a) to request
                confirmation of whether or not we process personal data relating
                to you, and if so, to request a copy of that data; (b) to
                request that we rectify or update your personal data that is
                inaccurate, incomplete, or outdated; (c) to request that we
                erase your personal data in certain circumstances, such as where
                we collected personal data on the basis of your consent and you
                later withdrew your consent; (d) to request that, in certain
                circumstances, we restrict the use of your personal data, such
                as while we consider another request you have submitted to us
                (e.g., a request that we update your personal data); (e) when
                you have given us consent to process your personal data, to
                withdraw that consent; and (f) to request, in certain
                circumstances, that we provide you with a copy of your personal
                data in a structured, commonly used, and machine readable
                format. To exercise your rights described above, please contact
                us by e-mail or as described in the “How to Contact Us” section
                of this Policy. You also have the right to lodge a complaint
                with the data protection supervisory authority in your country.
              </p>
              <br />
              <p>
                If you are a resident of California and have an established
                business relationship with us, California Civil Code Section
                1798.83 permits you to request a notice from us disclosing the
                categories of personal information we have shared with third
                parties, for the third parties’ direct marketing purposes,
                during the preceding calendar year. At this time, we do not
                share your Personal Information with third parties for third
                parties’ direct marketing purposes. To request such a notice,
                please submit your request to us via E-mail at:{" "}
                <strong>satoshi@oshi.tech</strong> or
              </p>
              <br />
              <p>
                Write to us at: <br />
                <strong>245 Lazy Creek Dr, Georgetown, TX 78628</strong>
              </p>
              <br />
              <p>Please allow 45 days for a response.</p>
              <br />
              <p>
                If you are a resident of California, under 18 years of age, and
                a registered user of our Oshi Platform, the California Business
                and Professions Code Section 22581 permits to you request that
                we remove content or information you publicly posted to our Oshi
                Platform or other online services. Please note that our
                fulfillment of your request may not ensure complete or
                comprehensive removal of the information you posted, such as, if
                the information you posted has been shared by another user. In
                addition, there may be circumstances in which the law does not
                require or allow removal, even if requested. To request removal
                of content or information you posted, please send a detailed
                description of the specific content or information and where it
                is posted to <strong>satoshi@oshi.tech</strong>.{" "}
              </p>
              <br />
              <p>
                <strong>Data Transfers</strong>
              </p>
              <br />
              <p>
                We may transfer the Personal Information we collect about you to
                recipients in countries other than the country in which the
                Personal Information was collected. Those countries may not have
                the same data protection laws as the country in which you
                initially provided the information. When we transfer your
                information to recipients in other countries (such as the EEA or
                Switzerland), we will protect that information as described in
                this Policy.
              </p>
              <br />
              <p>
                Our Oshi Platform and the servers that make this Oshi Platform
                available worldwide are located in the United States. The
                Internet laws in the United States govern all matters relating
                to this Oshi Platform. Any information you provide in
                subscribing to our Oshi Platform or registering or ordering at
                our Oshi Platform will be transferred to the United States. By
                visiting our Oshi Platform and submitting information, you
                authorize this transfer, processing, and use.
              </p>
              <br />
              <p>
                <strong>How We Protect Personal Information</strong>
              </p>
              <br />
              <p>
                We incorporate standard industry practices internally and with
                our service providers, which we believe suits the degree of
                sensitivity of the information involved to maintain the security
                of your Personal Information and to avoid its disclosure except
                as described in this Policy.
              </p>
              <p>
                Although we have implemented systems and procedures to secure
                the data maintained by us, security during Internet
                transmissions can never be assured. Our policy is to limit
                access to Personal Information to those Oshi employees or agents
                with a specific need to access or retrieve this information. We
                store data on multiple service systems in controlled
                environments. To maintain security, we conduct internal reviews
                of our security measures on a regular basis. Remember, however,
                that any Personal Information you post on the internet is
                available to anyone.
              </p>
              <br />

              <p>
                <strong>Links to Other Websites</strong>
              </p>
              <br />

              <p>
                The Oshi Platform may provide link to other websites. Companies
                other than Oshi may operate those websites. Linked websites may
                have their own online privacy policies, which we strongly
                suggest you review if you visit any linked website. We are not
                responsible for any use of website we do not operate, the
                content of any of those websites, or the privacy practices of
                those websites.
              </p>

              <br />
              <p>
                <strong>Children’s Privacy</strong>
              </p>
              <br />
              <p>
                None of the information on the Oshi Platform is intended for the
                use of children under thirteen (13) years of age, and Oshi does
                not knowingly register any person or accept information from any
                person under thirteen (13) years of age.
              </p>
              <br />
              <p>
                <strong>Resolution of Disputes</strong>
              </p>
              <br />
              <p>
                If a dispute, controversy or claim, of any kind and every kind
                or type, whether based on contract, tort, statute, regulations,
                or otherwise, arising out of, or connected with, or relating in
                any way to this Policy, or the relationship of the parties, or
                the obligations of the parties, or the scope of this arbitration
                agreement, of the operations carried out under this Policy,
                including without limitation, any dispute as to the existence,
                validity, construction, interpretation, negotiation,
                performance, non-performance, breach, termination, scope, or
                enforceability of this Policy, or the breach thereof (any one of
                which constituting the “Dispute”), and if the Dispute cannot be
                settled through direct discussions (in the opinion of any
                party), the parties agree to first endeavor to settle the
                Dispute in an amicable manner by mediation under the then
                current Commercial Mediation Rules of the American Arbitration
                Association (“AAA”), before resorting to arbitration. If the
                Dispute is not settled by mediation within thirty (30) days of
                written request for mediation by any party to AAA, then and
                thereafter any unresolved Dispute, including the arbitrability
                of any unresolved Dispute, shall be settled by arbitration
                administered by the American Arbitration Association (“AAA”) in
                accordance with the then current AAA Commercial Arbitration
                Rules with the award being final and binding. Judgment upon the
                award rendered by the arbitrator may be entered in any court
                having jurisdiction thereof. Any provisional remedy which would
                be available from a court of law shall be available from the
                arbitrator to the parties to this Policy pending arbitration.
                The Federal Arbitration Act shall govern all arbitration
                proceedings under this Policy. This Policy shall in all other
                respects be governed and interpreted by the laws of the State of
                Texas, including its statutes of limitation but excluding any
                conflicts or choice of law rule or principles that might
                otherwise refer construction or interpretation of this Policy to
                the substantive law of another jurisdiction. The arbitration
                shall be conducted in Fort Worth, Texas, by one neutral
                arbitrator chosen by AAA according to its Commercial Arbitration
                Rules. Neither party nor the arbitrator may disclose the
                existence, content, or results of any arbitration hereunder
                without the prior written consent of all parties. All fees and
                expenses of the arbitration shall be borne by the parties
                equally who shall make deposits as requested by AAA of each
                party’s share of the deposits requested. Failure or refusal by a
                party to pay its share of the requested deposits shall
                constitute a waiver by the non-paying party of its rights to be
                heard, present evidence, cross-examine witnesses, and assert
                counterclaims in the arbitration. Informing the arbitrator of a
                party’s failure to pay its share of the requested deposits for
                the purpose of implementing this waiver provision shall not be
                deemed to affect the arbitrator’s impartiality, neutrality,
                independence, or ability to proceed with the arbitration.
                However, each party shall bear the expense of its own counsel,
                experts, witnesses, and preparation and presentation of proofs.
                The prevailing party, according to the arbitrator, shall be
                entitled to an award of reasonable attorney’s fees for the
                arbitration and for all appeals of the award, arbitration fees
                and administrative expenses, and pre-award and post-award
                interest at the prevailing Texas statutory pre-judgment and
                post-judgment interest rates. This agreement to arbitrate shall
                survive the termination or repudiation of this Policy.
              </p>

              <br />
              <p>
                <strong>Updates to Our Privacy Policy</strong>
              </p>
              <br />
              <p>
                We will occasionally update this Policy as necessary to protect
                our users and to comply with a changing environment. We
                recommend that you check the Policy when you visit our Oshi
                Platform to be sure that you are aware of and understand our
                current privacy policy. If we make material changes to this
                Policy, or in how we use or collect your Personal Information,
                we will prominently post such changes prior to implementing the
                change. We will not make any retroactive material changes in how
                we handle previously collected Personal Information unless you
                allow us to do so, or unless we are legally required to do so,
                and in such a case we will e-mail registered Oshi Platform
                visitors information about material changes to this Policy.
              </p>
              <br />
              <p>
                <strong>How to Contact Us</strong>
              </p>
              <br />
              <p>
                If you have any questions about this Privacy Policy or would
                like to update information we have about you or your
                preferences, please contact us by one of the methods below.
                Please include the URL of the Oshi Platform involved in your
                request.
              </p>
              <br />
              <p>
                E-mail us at:
                <strong>satoshi@oshi.tech</strong>
              </p>
              <br />
              <p>
                Write to us at: <br />
                <strong>245 Lazy Creek Dr, Georgetown, TX 78628</strong>
              </p>
            </div>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </div>
  );
};
export default Privacy;
